import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Stack, Typography } from '@mui/material'

// What the window toggle's hover says, in two paragraphs: which months the figures cover,
// then which games they are measured across. Shared so the catalogue page and the detail
// pages' stat card, which both carry the toggle, can't word it differently.
export const WindowTooltipContent: FC = () => {
  const { t } = useTranslation()

  return (
    <Stack spacing={1}>
      <Typography variant="inherit">{t('market-analytics:tooltip_window')}</Typography>
      <Typography variant="inherit">{t('market-analytics:tooltip_window_cohort')}</Typography>
    </Stack>
  )
}
